<template>
  <div>
    <b-row class="mb-1">
      <b-col class="col-auto">
        <h4 class="mb-0">
          <i class="fa fa-music mt-1"></i>
        </h4>
      </b-col>
      <b-col>
        <b-form-input
          v-model="query"
          :placeholder="trans('search')"
          type="search"
          size="sm"
          class="mb-1"
          @search="onSearch"
          @keydown.enter="onSearch"
        />
        <tags-filter
          :organization="organization"
          multiple
          v-model="tags"
          type="audio"
          @input="onSearch"
          allow-none
          :is-none="tag_is_none"
          @is-none="tag_is_none = $event"
          :all-tags="all_tags"
          @all-tags="all_tags = $event"
        ></tags-filter>
        <small class="text-muted">
          {{ totalRows }}
        </small>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          id="your-audios"
          ref="table"
          class="bg-white table-row-click"
          bordered
          small
          responsive
          show-empty
          :fields="fields"
          :items="provider"
          :per-page="perPage"
          :current-page="currentPage"
          @row-clicked="onRowClick"
        >
          <template v-slot:empty>
            <p align="center">{{ trans('no_audio_found') }}</p>
          </template>
          <template v-slot:cell(name)="data">
            {{ data.value }}
            <sup v-if="data.item.publish_to_partner">
              <b-badge variant="primary">
                {{ organization.can_publish && organization.partner == data.item.publish_to_partner ? trans('published') : data.item.publish_to_partner }}
              </b-badge>
            </sup>
            <small class="d-block mt-2 text-muted">
              {{ data.item.short_url }}
            </small>
          </template>
        </b-table>
        <b-pagination
          :per-page="perPage"
          :current-page="currentPage"
          :total-rows="totalRows"
          v-model="currentPage"
          aria-controls="your-audios"
          align="center"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import Tags from './../tag/Tags'
  import TagsFilter from './../tag/TagsFilter'

  export default {
    props: {
      organization: Object,
      zoom: Object,
      hideUpload: Boolean,
      search: String,
      perPage: {
        type: Number,
        default: 5
      },
    },
    components: {
      Tags,
      TagsFilter,
    },
    data() {
      let fields = [
        {key: 'name', label: trans('name'), class: 'table-row-width-200'},
      ]
      return {
        trans: trans,
        moment: moment,
        error: null,
        busy: false,
        fields: fields,
        items: [],
        currentPage: 1,
        totalRows: 0,
        item: null,
        query: this.search || null,
        tags: null,
        all_tags: null,
        tag_is_none: false,
      }
    },
    methods: {
      onSearch() {
        this.currentPage = 1
        this.$refs.table.refresh()
        this.$emit('search', this.query)
      },
      onUploaded(media) {
        if (media.id) {
          this.currentPage = 1
          this.onRefresh()
        }
        else if (media.message) {
          _.toastSuccess(this, media.message)
          setTimeout(() => {
            this.onRefresh()
          }, 5000)
        }
      },
      onRefresh() {
        this.$refs.table.refresh()
      },
      onRowClick(item) {
        this.$emit('choose', item)
      },
      provider() {
        this.error = null
        this.busy = true
        let url = `/organization/${this.organization.id}/media/audio?page=${this.currentPage}&per_page=${this.perPage}`
        if (this.query) url += '&name=' + encodeURIComponent(this.query)
        if (this.tag_is_none) url += `&tag=__none__`
        else if (this.tags && this.tags.length > 0) {
          this.tags.forEach(tag => {
            url += `&tags[]=${encodeURIComponent(tag)}`
          })
        }
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.currentPage = response.data.current_page
          this.totalRows = response.data.total
          this.items = response.data.data
          return this.items
        })
        .catch(error => {
          this.busy = false
          this.handleError(error)
          this.items = []
          return this.items
        })
      },
      handleError(error) {
        this.busy = false
        this.error = _.errorFromAjax(error)
        this.$bvToast.toast(this.error, {
          title: trans('error'),
          variant: 'danger',
          solid: true,
        })
      }
    },
    mounted() {
      window.audiosTableComponent = this
    },
  }
</script>